// removed by extract-text-webpack-plugin
module.exports = {"dialog":"Dialog__dialog___2EE79","heading":"Dialog__heading___160Is","close":"Dialog__close___14AWA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Dialog/Dialog.css
// module id = 869
// module chunks = 0